import { render } from "./TradeCardGP.vue?vue&type=template&id=a5fe7c60&scoped=true&ts=true"
import script from "./TradeCardGP.vue?vue&type=script&lang=ts"
export * from "./TradeCardGP.vue?vue&type=script&lang=ts"

import "./TradeCardGP.vue?vue&type=style&index=0&id=a5fe7c60&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fe7c60"]])

export default __exports__